// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609140234/js/" + chunkId + "." + {"44":"e9ee663d","225":"ffdedcf8","481":"c80882e1","486":"955ac76d","770":"113f820a"}[chunkId] + ".0.5497926262058169.chunk.js";
};